import { render, staticRenderFns } from "./peopleUploadFiles.vue?vue&type=template&id=43bc6d51&scoped=true"
import script from "./peopleUploadFiles.vue?vue&type=script&lang=js"
export * from "./peopleUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./peopleUploadFiles.vue?vue&type=style&index=0&id=43bc6d51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc6d51",
  null
  
)

export default component.exports